// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__3_VRr","whiteLogo":"whiteLogo__3K6HX","linkSection":"linkSection__2Dsl5","linkItems":"linkItems__2F98F","footerLink":"footerLink__3ntqA","copyrightDetails":"copyrightDetails__3tj_v"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.scss
// module id = R99g
// module chunks = 22